//奖学助学金活动路由
const grantActRouter = [
    

    {
        path: '/grantCheckUser',
        name: 'grantCheckUser',
        meta: {
            title: "认证" 
        },
        component: (resolve) => {
            require(['@/components/grantAct/grantCheckUser.vue'], resolve)
        }
    },
    
    {
        path: '/grantForm',
        name: 'grantForm',
        meta: {
            title: "奖学金学生基本信息" 
        },
        component: (resolve) => {
            require(['@/components/grantAct/grantForm.vue'], resolve)
        }
    },
    
    {
        path: '/scholarshipForm',
        name: 'scholarshipForm',
        meta: {
            title: "助学金学生基本信息" 
        },
        component: (resolve) => {
            require(['@/components/grantAct/scholarshipForm.vue'], resolve)
        }
    },
    
    {
        path: '/applicationSelection',
        name: 'applicationSelectiom',
        meta: {
            title: "报名选择" 
        },
        component: (resolve) => {
            require(['@/components/grantAct/applicationSelection.vue'], resolve)
        }
    },
    
    {
        path: '/vote',
        name: 'vote',
        meta: {
            title: "投票" 
        },
        component: (resolve) => {
            require(['@/components/grantAct/vote.vue'], resolve)
        }
    },
    {
        path: '/voteShare',
        name: 'voteShare',
        meta: {
            title: "您已报名-排行榜" 
        },
        component: (resolve) => {
            require(['@/components/grantAct/voteShare.vue'], resolve)
        }
    }
]
//Application selection
export default grantActRouter 


// WEBPACK FOOTER //
// ./src/router/grantRouter.js